export * from './delete-herausgeber-request.interface';
export * from './delete-herausgeber-response.interface';
export * from './delete-herausgeber.shapes';
